module.exports = __webpack_public_path__ + "static/media/MIT OCW Logo.6a460e60.png";